import styled from 'styled-components';
import {dFlexColumnCenter} from '../../../../globalVariables/GlobalFlex';

export const box = styled.div<{$square?: boolean}>`
    ${dFlexColumnCenter};
    flex: none;
    gap: var(--space-2xs);
    background: var(--color-bg-surface-default);
    border-radius: var(--border-radius-border-radius-md);
    width: ${({$square}) => ($square ? '42px' : '50px')};
    height: ${({$square}) => ($square ? '42px' : 'auto')};
    padding: ${({$square}) => ($square ? '0' : 'var(--space-xs) 0')};
    line-height: 1;
`;

export const day = styled.b<{$square?: boolean}>`
    font-size: ${({$square}) => ($square ? 'var(--font-size-heading-card)' : 'var(--font-size-body-small)')};
    font-weight: var(--font-weight-bold);
    line-height: 1.1;
`;

export const secondary = styled.span<{$square?: boolean}>`
    font-size: var(--font-size-helper);
    font-weight: var(--font-weight-regular);
    color: ${({$square}) => ($square ? 'var(--color-text-default)' : 'var(--color-text-subtle)')};
`;
